export default "__VITE_ASSET__CdMxu2vD__"